<template>

  <Head title="Tambah Dokumen" />
  <Container>
    <template #header>
      <Header :menu="$page.props.main_menu" v-if="$page.props.auth.user" />
    </template>
    <template #default>
      <div class="container px-4 mx-auto">
        <Breadcrumbs :breadcrumbs="[
          { name: 'Dashboard', href: route('dashboard') },
          { name: `Dokumen Audit Mutu`, href: route('auditmutu.index') },
          {
            name: `${standar.data[0].standar || 'N/A'}`,
            href: route('auditmutu.adddocument', standar.data[0].slug || 'N/A'),
          },
        ]" />
        <div class="flex flex-col items-start gap-4 md:flex-row md:items-center md:justify-between">
          <div>
            <h1 class="text-2xl font-bold text-gray-900 sm:text-3xl">
              {{ standar.data[0].standar }}
            </h1>
          </div>
          <div class="flex items-center gap-4">
            <p class="text-sm text-gray-500">
              Dokumen Audit Mutu /
              {{ standar.data[0]?.standar || "N/A" }}
            </p>
            <button @click="openTrash"
              class="px-3 py-1 text-xs font-semibold text-white bg-gray-700 rounded hover:bg-gray-800">Trash</button>
          </div>
        </div>

        <div class="col-span-1 p-4 lg:col-span-2">
          <div class="grid grid-cols-1 gap-4 lg:grid-cols-3 lg:gap-8">
            <!-- Left Column: Form & Folder Creation -->
            <div class="h-auto space-y-4">
              <FormAdd :standars="standar" :program="programs" :parent-folder-id="currentFolder?.id"
                :parent-folder-name="currentFolder?.nama_dok" />

            </div>

            <!-- Right Column: Listing -->
            <div class="h-auto rounded-lg lg:col-span-2">
              <div class="overflow-hidden bg-white border rounded-lg shadow">
                <div class="px-4 py-2 overflow-hidden text-sm font-medium text-gray-900 border-b bg-gray-50">
                  <h1>{{ standar.data[0].standar }}</h1>
                </div>
                <div class="p-4 overflow-x-auto">
                  <!-- Filters -->
                  <div class="flex flex-wrap items-center justify-between gap-3 mb-4">
                    <div class="flex items-center gap-2">
                      <label class="text-xs font-medium text-gray-600">Cari:</label>
                      <input v-model="localSearch" @keyup.enter="applyFilters" type="text"
                        placeholder="Nama / deskripsi"
                        class="px-2 py-1 text-sm border rounded focus:outline-none focus:ring focus:border-indigo-400" />
                      <button @click="applyFilters"
                        class="px-3 py-1 text-xs font-semibold text-white bg-indigo-600 rounded hover:bg-indigo-700">Cari</button>
                      <button v-if="localSearch" @click="resetFilters"
                        class="px-2 py-1 text-xs text-gray-600 bg-gray-100 border rounded hover:bg-gray-200">Reset</button>
                    </div>
                    <div class="flex items-center gap-2">
                      <label class="text-xs font-medium text-gray-600">Per Page:</label>
                      <select v-model.number="pageSize" @change="applyFilters"
                        class="px-2 py-1 text-xs border rounded focus:outline-none focus:ring focus:border-indigo-400">
                        <option :value="10">10</option>
                        <option :value="25">25</option>
                        <option :value="50">50</option>
                      </select>
                    </div>
                  </div>
                  <!-- Tag Filter Chips -->
                  <div v-if="availableTags.length" class="flex flex-wrap items-center gap-2 mb-4">
                    <span class="text-[11px] font-semibold uppercase text-gray-500">Filter Tags:</span>
                    <button v-for="tag in availableTags" :key="tag.slug" type="button" @click="toggleTag(tag.slug)"
                      class="px-2 py-0.5 rounded text-[11px] border transition"
                      :class="selectedTags.includes(tag.slug) ? 'bg-indigo-600 text-white border-indigo-600' : 'bg-white text-gray-700 hover:bg-gray-100 border-gray-300'">
                      {{ tag.name }}
                    </button>
                    <button v-if="selectedTags.length" @click="clearTags" type="button"
                      class="px-2 py-0.5 text-[11px] text-gray-600 bg-gray-100 border border-gray-300 rounded hover:bg-gray-200">Clear</button>
                  </div>

                  <!-- Breadcrumbs inside listing -->
                  <div v-if="folderBreadcrumbs.length"
                    class="flex flex-wrap items-center mb-3 text-xs text-gray-600 gap-x-1">
                    <span @click="goToRoot" class="cursor-pointer hover:underline">Root</span>
                    <template v-for="(f, i) in folderBreadcrumbs" :key="f.id">
                      <span>/</span>
                      <span @click="navigateToFolder(f.id)" class="cursor-pointer hover:underline"
                        :class="{ 'font-semibold': i === folderBreadcrumbs.length - 1 }">{{ f.nama_dok }}</span>
                    </template>
                  </div>

                  <!-- Table -->
                  <table class="w-full table-auto">
                    <thead>
                      <tr class="text-xs font-medium text-left text-gray-500 uppercase">
                        <th class="px-2 py-2"><input type="checkbox" v-model="allSelected" @change="toggleSelectAll" />
                        </th>
                        <th class="px-4 py-2">No</th>
                        <th class="px-4 py-2">Nama</th>
                        <th class="px-4 py-2">Jenis Dokumen</th>
                        <th class="px-4 py-2">Tags</th>
                        <th class="px-4 py-2">Aksi</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(folder, fIndex) in folders" :key="'folder-' + folder.id" :data-folder-row="folder.id"
                        class="border-b hover:bg-indigo-50 group" draggable="true"
                        @dragstart="onDragStart(folder.id, true)" @dragover.prevent="onDragOverFolder(folder.id)"
                        @dragleave="onDragLeaveFolder(folder.id)" @drop.prevent="onDropOnFolder(folder.id)">
                        <td class="px-2 py-2"><input type="checkbox" :value="{ id: folder.id, type: 'folder' }"
                            v-model="selectedItems" @click.stop /></td>
                        <td class="px-4 py-2 text-sm text-gray-900 whitespace-nowrap">F{{ fIndex + 1 }}.</td>
                        <td class="flex items-center gap-2 px-4 py-2 text-sm text-indigo-600 whitespace-nowrap">
                          <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4 text-yellow-500" fill="currentColor"
                            viewBox="0 0 20 20">
                            <path
                              d="M2 6a2 2 0 012-2h3.5a1 1 0 01.8.4l1.2 1.6H16a2 2 0 012 2v5a2 2 0 01-2 2H4a2 2 0 01-2-2V6z" />
                          </svg>
                          <span v-if="!isRenaming('folder', folder.id)" @click="navigateToFolder(folder.id)"
                            class="cursor-pointer hover:underline">{{ folder.nama_dok }} <span
                              class="text-xs text-gray-500" v-if="folder.file_count">({{ folder.file_count
                              }})</span></span>
                          <input v-else type="text" v-model="renameState.name"
                            @keyup.enter="confirmRename(folder.id, true)" @blur="cancelRename"
                            class="px-1 py-0.5 text-xs border rounded" />
                        </td>
                        <td class="px-4 py-2 text-sm text-gray-500 whitespace-nowrap">Folder</td>
                        <td class="px-4 py-2 text-xs whitespace-nowrap">
                          <TagList :repository-id="folder.id" :initial="folder.tags || []" />
                        </td>
                        <td class="px-4 py-2 text-xs text-gray-500 whitespace-nowrap">
                          <div class="flex items-center gap-2 transition opacity-0 group-hover:opacity-100">
                            <button @click.stop="startRename('folder', folder.id, folder.nama_dok)"
                              class="text-indigo-600 hover:underline">Rename</button>
                            <button @click.stop="openMove(folder.id)"
                              class="text-teal-600 hover:underline">Move</button>
                            <button @click.stop="exportFolder(folder.id)"
                              class="text-slate-600 hover:underline">Export</button>
                            <button @click.stop="confirmDelete(folder.id)"
                              class="text-red-600 hover:underline">Delete</button>
                          </div>
                        </td>
                      </tr>
                      <tr v-for="(dokumen, index) in files.data" :key="index" class="border-b hover:bg-gray-50"
                        :data-iddok="dokumen.iddok" draggable="true" @dragstart="onDragStart(dokumen.id, false)">
                        <td class="px-2 py-2"><input type="checkbox" :value="{ id: dokumen.id, type: 'file' }"
                            v-model="selectedItems" @click.stop /></td>
                        <td class="px-4 py-2 text-sm text-gray-900 whitespace-nowrap">{{ index + 1 }}.</td>
                        <td class="px-4 py-2 text-sm text-gray-900 whitespace-nowrap">
                          <div class="flex items-center gap-2">
                            <!-- File Type Badge -->
                            <div class="inline-flex items-center px-1.5 py-0.5 rounded text-xs font-medium"
                              :class="[getFileTypeInfo(dokumen.nama_dok).bg, getFileTypeInfo(dokumen.nama_dok).color]">
                              {{ getFileTypeInfo(dokumen.nama_dok).name }}
                            </div>
                            <span v-if="!isRenaming('file', dokumen.id)" @click="openPreview(dokumen.id)"
                              class="cursor-pointer hover:underline">{{ dokumen.nama_dok }}</span>
                            <input v-else type="text" v-model="renameState.name"
                              @keyup.enter="confirmRename(dokumen.id, false)" @blur="cancelRename"
                              class="px-1 py-0.5 text-xs border rounded" />
                          </div>
                        </td>
                        <td class="px-4 py-2 text-sm text-gray-900 whitespace-nowrap">
                          {{ (dokumen.jenisdokumen && dokumen.jenisdokumen.nama) ? dokumen.jenisdokumen.nama
                            : (dokumen.jenis_dokumen && dokumen.jenis_dokumen.nama) ? dokumen.jenis_dokumen.nama
                              : '-' }}
                        </td>
                        <td class="px-4 py-2 text-xs whitespace-nowrap">
                          <TagList :repository-id="dokumen.id" :initial="dokumen.tags || []" />
                        </td>
                        <td class="relative px-4 py-2 text-sm text-gray-900 whitespace-nowrap">
                          <div class="relative inline-block text-left">
                            <button @click.stop="toggleMenu(dokumen.id)"
                              class="inline-flex items-center gap-1 px-2 py-1 text-xs font-semibold text-gray-700 bg-white border rounded hover:bg-gray-100">
                              Aksi
                              <svg class="w-3 h-3" viewBox="0 0 20 20" fill="currentColor">
                                <path fill-rule="evenodd"
                                  d="M5.23 7.21a.75.75 0 011.06.02L10 11.207l3.71-3.976a.75.75 0 111.08 1.04l-4.24 4.54a.75.75 0 01-1.08 0L5.21 8.27a.75.75 0 01.02-1.06z"
                                  clip-rule="evenodd" />
                              </svg>
                            </button>
                            <div v-if="openMenuFor === dokumen.id"
                              class="absolute right-0 z-20 w-40 mt-1 origin-top-right bg-white rounded-md shadow-lg ring-1 ring-black ring-opacity-5">
                              <div class="py-1 text-xs">
                                <button @click.stop="openPreview(dokumen.id); closeMenu()"
                                  class="block w-full px-3 py-1 text-left hover:bg-gray-100">Preview</button>
                                <button @click.stop="startRename('file', dokumen.id, dokumen.nama_dok); closeMenu()"
                                  class="block w-full px-3 py-1 text-left hover:bg-gray-100">Rename</button>
                                <button @click.stop="openMove(dokumen.id); closeMenu()"
                                  class="block w-full px-3 py-1 text-left hover:bg-gray-100">Move</button>
                                <button @click.stop="openHistory(dokumen.id); closeMenu()"
                                  class="block w-full px-3 py-1 text-left hover:bg-gray-100">History</button>
                                <button @click.stop="openReplace(dokumen); closeMenu()"
                                  class="block w-full px-3 py-1 text-left hover:bg-gray-100">Replace</button>
                                <button @click.stop="confirmDelete(dokumen.id); closeMenu()"
                                  class="block w-full px-3 py-1 text-left text-red-600 hover:bg-red-50">Delete</button>
                              </div>
                            </div>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>

                  <!-- Bulk selection toolbar -->
                  <div v-if="selectedItems.length" class="sticky left-0 right-0 mt-4 bottom-2">
                    <div class="flex flex-wrap items-center gap-3 p-3 text-xs bg-white border rounded shadow">
                      <span class="font-medium">Dipilih: {{ selectedItems.length }}</span>
                      <button @click="bulkDelete"
                        class="px-2 py-1 font-semibold text-white bg-red-600 rounded hover:bg-red-700">Hapus</button>
                      <button @click="openBulkMove"
                        class="px-2 py-1 font-semibold text-white bg-teal-600 rounded hover:bg-teal-700">Pindahkan</button>
                      <button @click="clearSelection"
                        class="px-2 py-1 text-gray-600 bg-gray-100 rounded hover:bg-gray-200">Bersihkan</button>
                    </div>
                  </div>
                </div>
                <!-- Pagination / Summary -->
                <div class="px-4 py-2 text-sm font-medium text-gray-900 border-t bg-gray-50">
                  <p class="text-sm text-gray-500">Menampilkan <span class="font-semibold text-gray-900">{{ pageCount
                  }}</span> dari
                    <span class="font-semibold text-gray-900">{{ totalDocs }}</span> data dokumen.
                  </p>
                  <div v-if="paginationLinks.length > 3" class="flex flex-wrap items-center gap-1 mt-3">
                    <button v-for="(link, i) in paginationLinks" :key="i" :disabled="!link.url"
                      @click="changePage(link)" v-html="sanitizeLabel(link.label)"
                      class="px-3 py-1 text-xs transition border rounded"
                      :class="[link.active ? 'bg-indigo-600 text-white border-indigo-600' : 'bg-white text-gray-700 hover:bg-gray-100', !link.url && !link.active ? 'cursor-not-allowed opacity-40' : '']" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Modals (moved inside single root template) -->
      <div v-if="previewModal.open" class="fixed inset-0 z-50 flex items-center justify-center bg-black/50">
        <div class="w-full max-w-3xl p-4 bg-white rounded shadow-lg">
          <div class="flex items-center justify-between mb-3">
            <div class="flex items-center gap-3">
              <!-- File Type Badge -->
              <div class="inline-flex items-center px-2 py-1 text-xs font-medium rounded-full"
                :class="[getFileTypeInfo(previewModal.item?.nama_dok || '').bg, getFileTypeInfo(previewModal.item?.nama_dok || '').color]">
                <svg class="w-3 h-3 mr-1" fill="currentColor" viewBox="0 0 20 20">
                  <path fill-rule="evenodd"
                    d="M3 17a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM6.293 6.707a1 1 0 010-1.414l3-3a1 1 0 011.414 0l3 3a1 1 0 01-1.414 1.414L11 4.414V13a1 1 0 11-2 0V4.414L7.707 5.707a1 1 0 01-1.414 0z"
                    clip-rule="evenodd" />
                </svg>
                {{ getFileTypeInfo(previewModal.item?.nama_dok || '').name }}
              </div>
              <h2 class="text-sm font-semibold">{{ previewModal.item?.nama_dok }}</h2>
            </div>
            <button @click="closePreview" class="flex items-center text-xs text-gray-500 hover:text-gray-700">
              <svg class="w-4 h-4 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
              </svg>
              Tutup
            </button>
          </div>

          <div v-if="isImage(previewModal.primaryFile)" class="overflow-auto max-h-[70vh]">
            <img :src="imageSrc" class="max-w-full rounded" alt="Preview image" />
          </div>
          <div v-else-if="isPdf(previewModal.primaryFile)" class="h-[70vh]">
            <object :data="pdfSrc" type="application/pdf" class="w-full h-full border rounded">
              <iframe :src="pdfSrc" class="w-full h-full border rounded"></iframe>
              <p class="mt-2 text-xs text-gray-500">
                PDF tidak bisa ditampilkan di sini.
                <a :href="previewModal.primaryFile" target="_blank" class="text-indigo-600 underline">Buka di tab
                  baru</a>
              </p>
            </object>
          </div>
          <!-- Excel File Preview -->
          <div v-else-if="isExcel(previewModal.primaryFile)" class="h-[70vh]">
            <div v-if="showOfficePreview" class="h-full">
              <iframe :src="getOfficeViewerUrl('excel')" class="w-full h-full border rounded"
                @error="handleOfficePreviewError">
              </iframe>
              <div class="flex items-center justify-between mt-2">
                <p class="text-xs text-gray-500">Preview via Microsoft Office Online</p>
                <button @click="showOfficePreview = false" class="text-xs text-gray-600 underline hover:text-gray-800">
                  Tampilkan opsi lain
                </button>
              </div>
            </div>
            <div v-else
              class="flex items-center justify-center h-full border-2 border-green-200 border-dashed rounded bg-green-50">
              <div class="text-center">
                <div class="mb-4">
                  <svg class="w-16 h-16 mx-auto text-green-600" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M14,2H6A2,2 0 0,0 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2M18,20H6V4H13V9H18V20Z" />
                  </svg>
                </div>
                <h3 class="mb-2 text-sm font-semibold text-gray-900">File Excel</h3>
                <p class="mb-4 text-xs text-gray-600">{{ previewModal.item?.nama_dok }}</p>
                <div class="flex flex-col gap-2">
                  <button @click="showOfficePreview = true"
                    class="inline-flex items-center px-3 py-2 text-xs font-medium text-white bg-green-600 rounded hover:bg-green-700">
                    <svg class="w-4 h-4 mr-2" fill="currentColor" viewBox="0 0 20 20">
                      <path fill-rule="evenodd"
                        d="M10 18a8 8 0 100-16 8 8 0 000 16zM9.555 7.168A1 1 0 008 8v4a1 1 0 001.555.832L12 11.202a1 1 0 000-1.404l-2.445-1.63z"
                        clip-rule="evenodd" />
                    </svg>
                    Preview Online
                  </button>
                  <button @click="openGoogleViewer()"
                    class="inline-flex items-center px-3 py-2 text-xs font-medium text-green-700 bg-green-100 rounded hover:bg-green-200">
                    <svg class="w-4 h-4 mr-2" fill="currentColor" viewBox="0 0 20 20">
                      <path
                        d="M12.017 11.986a.264.264 0 01-.634.064l-.468-.453a.265.265 0 01.035-.461l1.211-.507a.265.265 0 01.35.095l.165.35a.264.264 0 01-.123.353l-.536.559z" />
                    </svg>
                    Google Viewer
                  </button>
                  <a :href="previewModal.primaryFile" target="_blank"
                    class="inline-flex items-center px-3 py-2 text-xs font-medium text-gray-700 bg-gray-100 rounded hover:bg-gray-200">
                    <svg class="w-4 h-4 mr-2" fill="currentColor" viewBox="0 0 20 20">
                      <path fill-rule="evenodd"
                        d="M3 17a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm3.293-7.707a1 1 0 011.414 0L9 10.586V3a1 1 0 112 0v7.586l1.293-1.293a1 1 0 111.414 1.414l-3 3a1 1 0 01-1.414 0l-3-3a1 1 0 010-1.414z"
                        clip-rule="evenodd" />
                    </svg>
                    Download File
                  </a>
                </div>
              </div>
            </div>
          </div>
          <!-- Word Document Preview -->
          <div v-else-if="isWord(previewModal.primaryFile)" class="h-[70vh]">
            <div v-if="showOfficePreview" class="h-full">
              <iframe :src="getOfficeViewerUrl('word')" class="w-full h-full border rounded"
                @error="handleOfficePreviewError">
              </iframe>
              <div class="flex items-center justify-between mt-2">
                <p class="text-xs text-gray-500">Preview via Microsoft Office Online</p>
                <button @click="showOfficePreview = false" class="text-xs text-gray-600 underline hover:text-gray-800">
                  Tampilkan opsi lain
                </button>
              </div>
            </div>
            <div v-else
              class="flex items-center justify-center h-full border-2 border-blue-200 border-dashed rounded bg-blue-50">
              <div class="text-center">
                <div class="mb-4">
                  <svg class="w-16 h-16 mx-auto text-blue-600" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M14,2H6A2,2 0 0,0 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2M18,20H6V4H13V9H18V20Z" />
                  </svg>
                </div>
                <h3 class="mb-2 text-sm font-semibold text-gray-900">Dokumen Word</h3>
                <p class="mb-4 text-xs text-gray-600">{{ previewModal.item?.nama_dok }}</p>
                <div class="flex flex-col gap-2">
                  <button @click="showOfficePreview = true"
                    class="inline-flex items-center px-3 py-2 text-xs font-medium text-white bg-blue-600 rounded hover:bg-blue-700">
                    <svg class="w-4 h-4 mr-2" fill="currentColor" viewBox="0 0 20 20">
                      <path fill-rule="evenodd"
                        d="M10 18a8 8 0 100-16 8 8 0 000 16zM9.555 7.168A1 1 0 008 8v4a1 1 0 001.555.832L12 11.202a1 1 0 000-1.404l-2.445-1.63z"
                        clip-rule="evenodd" />
                    </svg>
                    Preview Online
                  </button>
                  <button @click="openGoogleViewer()"
                    class="inline-flex items-center px-3 py-2 text-xs font-medium text-blue-700 bg-blue-100 rounded hover:bg-blue-200">
                    <svg class="w-4 h-4 mr-2" fill="currentColor" viewBox="0 0 20 20">
                      <path
                        d="M12.017 11.986a.264.264 0 01-.634.064l-.468-.453a.265.265 0 01.035-.461l1.211-.507a.265.265 0 01.35.095l.165.35a.264.264 0 01-.123.353l-.536.559z" />
                    </svg>
                    Google Viewer
                  </button>
                  <a :href="previewModal.primaryFile" target="_blank"
                    class="inline-flex items-center px-3 py-2 text-xs font-medium text-gray-700 bg-gray-100 rounded hover:bg-gray-200">
                    <svg class="w-4 h-4 mr-2" fill="currentColor" viewBox="0 0 20 20">
                      <path fill-rule="evenodd"
                        d="M3 17a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm3.293-7.707a1 1 0 011.414 0L9 10.586V3a1 1 0 112 0v7.586l1.293-1.293a1 1 0 111.414 1.414l-3 3a1 1 0 01-1.414 0l-3-3a1 1 0 010-1.414z"
                        clip-rule="evenodd" />
                    </svg>
                    Download File
                  </a>
                </div>
              </div>
            </div>
          </div>
          <!-- PowerPoint Preview -->
          <div v-else-if="isPowerPoint(previewModal.primaryFile)" class="h-[70vh]">
            <div v-if="showOfficePreview" class="h-full">
              <iframe :src="getOfficeViewerUrl('powerpoint')" class="w-full h-full border rounded"
                @error="handleOfficePreviewError">
              </iframe>
              <div class="flex items-center justify-between mt-2">
                <p class="text-xs text-gray-500">Preview via Microsoft Office Online</p>
                <button @click="showOfficePreview = false" class="text-xs text-gray-600 underline hover:text-gray-800">
                  Tampilkan opsi lain
                </button>
              </div>
            </div>
            <div v-else
              class="flex items-center justify-center h-full border-2 border-orange-200 border-dashed rounded bg-orange-50">
              <div class="text-center">
                <div class="mb-4">
                  <svg class="w-16 h-16 mx-auto text-orange-600" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M14,2H6A2,2 0 0,0 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2M18,20H6V4H13V9H18V20Z" />
                  </svg>
                </div>
                <h3 class="mb-2 text-sm font-semibold text-gray-900">Presentasi PowerPoint</h3>
                <p class="mb-4 text-xs text-gray-600">{{ previewModal.item?.nama_dok }}</p>
                <div class="flex flex-col gap-2">
                  <button @click="showOfficePreview = true"
                    class="inline-flex items-center px-3 py-2 text-xs font-medium text-white bg-orange-600 rounded hover:bg-orange-700">
                    <svg class="w-4 h-4 mr-2" fill="currentColor" viewBox="0 0 20 20">
                      <path fill-rule="evenodd"
                        d="M10 18a8 8 0 100-16 8 8 0 000 16zM9.555 7.168A1 1 0 008 8v4a1 1 0 001.555.832L12 11.202a1 1 0 000-1.404l-2.445-1.63z"
                        clip-rule="evenodd" />
                    </svg>
                    Preview Online
                  </button>
                  <button @click="openGoogleViewer()"
                    class="inline-flex items-center px-3 py-2 text-xs font-medium text-orange-700 bg-orange-100 rounded hover:bg-orange-200">
                    <svg class="w-4 h-4 mr-2" fill="currentColor" viewBox="0 0 20 20">
                      <path
                        d="M12.017 11.986a.264.264 0 01-.634.064l-.468-.453a.265.265 0 01.035-.461l1.211-.507a.265.265 0 01.35.095l.165.35a.264.264 0 01-.123.353l-.536.559z" />
                    </svg>
                    Google Viewer
                  </button>
                  <a :href="previewModal.primaryFile" target="_blank"
                    class="inline-flex items-center px-3 py-2 text-xs font-medium text-gray-700 bg-gray-100 rounded hover:bg-gray-200">
                    <svg class="w-4 h-4 mr-2" fill="currentColor" viewBox="0 0 20 20">
                      <path fill-rule="evenodd"
                        d="M3 17a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm3.293-7.707a1 1 0 011.414 0L9 10.586V3a1 1 0 112 0v7.586l1.293-1.293a1 1 0 111.414 1.414l-3 3a1 1 0 01-1.414 0l-3-3a1 1 0 010-1.414z"
                        clip-rule="evenodd" />
                    </svg>
                    Download File
                  </a>
                </div>
              </div>
            </div>
          </div>
          <!-- Text File Preview -->
          <div v-else-if="isTextFile(previewModal.primaryFile)" class="h-[70vh]">
            <div v-if="showTextPreview && textPreview.content" class="h-full">
              <div class="flex flex-col h-full">
                <div class="flex items-center justify-between p-2 mb-2 bg-gray-100 rounded">
                  <p class="text-xs text-gray-600">Preview konten file</p>
                  <button @click="showTextPreview = false" class="text-xs text-gray-600 underline hover:text-gray-800">
                    Kembali ke opsi
                  </button>
                </div>
                <div class="flex-1 overflow-auto">
                  <pre class="p-3 font-mono text-xs whitespace-pre-wrap bg-white border rounded">{{ textPreview.content }}
            </pre>
                </div>
              </div>
            </div>
            <div v-else
              class="flex items-center justify-center h-full border-2 border-gray-200 border-dashed rounded bg-gray-50">
              <div class="text-center">
                <div class="mb-4">
                  <svg class="w-16 h-16 mx-auto text-gray-600" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M14,2H6A2,2 0 0,0 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2M18,20H6V4H13V9H18V20Z" />
                  </svg>
                </div>
                <h3 class="mb-2 text-sm font-semibold text-gray-900">File Text</h3>
                <p class="mb-4 text-xs text-gray-600">{{ previewModal.item?.nama_dok }}</p>
                <div class="flex flex-col gap-2">
                  <button @click="loadTextPreview()" :disabled="textPreview.loading"
                    class="inline-flex items-center px-3 py-2 text-xs font-medium text-white bg-gray-600 rounded hover:bg-gray-700 disabled:opacity-50">
                    <svg v-if="!textPreview.loading" class="w-4 h-4 mr-2" fill="currentColor" viewBox="0 0 20 20">
                      <path fill-rule="evenodd"
                        d="M10 18a8 8 0 100-16 8 8 0 000 16zM9.555 7.168A1 1 0 008 8v4a1 1 0 001.555.832L12 11.202a1 1 0 000-1.404l-2.445-1.63z"
                        clip-rule="evenodd" />
                    </svg>
                    <svg v-else class="w-4 h-4 mr-2 animate-spin" fill="currentColor" viewBox="0 0 20 20">
                      <path
                        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" />
                    </svg>
                    {{ textPreview.loading ? 'Loading...' : 'Preview Content' }}
                  </button>
                  <a :href="previewModal.primaryFile" target="_blank"
                    class="inline-flex items-center px-3 py-2 text-xs font-medium text-gray-700 bg-gray-100 rounded hover:bg-gray-200">
                    <svg class="w-4 h-4 mr-2" fill="currentColor" viewBox="0 0 20 20">
                      <path fill-rule="evenodd"
                        d="M3 17a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm3.293-7.707a1 1 0 011.414 0L9 10.586V3a1 1 0 112 0v7.586l1.293-1.293a1 1 0 111.414 1.414l-3 3a1 1 0 01-1.414 0l-3-3a1 1 0 010-1.414z"
                        clip-rule="evenodd" />
                    </svg>
                    Download File
                  </a>
                </div>
                <p v-if="textPreview.error" class="mt-2 text-xs text-red-600">{{ textPreview.error }}</p>
              </div>
            </div>
          </div>
          <!-- Fallback for unsupported files -->
          <div v-else class="h-[70vh]">
            <div
              class="flex items-center justify-center h-full border-2 border-gray-200 border-dashed rounded bg-gray-50">
              <div class="text-center">
                <div class="mb-4">
                  <svg class="w-16 h-16 mx-auto text-gray-400" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M14,2H6A2,2 0 0,0 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2M18,20H6V4H13V9H18V20Z" />
                  </svg>
                </div>
                <h3 class="mb-2 text-sm font-semibold text-gray-900">File tidak dapat dipratinjau</h3>
                <p class="mb-4 text-xs text-gray-600">{{ previewModal.item?.nama_dok }}</p>
                <p class="mb-4 text-xs text-gray-500">
                  Format file ini tidak mendukung preview online.<br>
                  Silakan download untuk membuka file.
                </p>
                <a :href="previewModal.primaryFile" target="_blank"
                  class="inline-flex items-center px-4 py-2 text-sm font-medium text-white bg-indigo-600 rounded hover:bg-indigo-700">
                  <svg class="w-4 h-4 mr-2" fill="currentColor" viewBox="0 0 20 20">
                    <path fill-rule="evenodd"
                      d="M3 17a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm3.293-7.707a1 1 0 011.414 0L9 10.586V3a1 1 0 112 0v7.586l1.293-1.293a1 1 0 111.414 1.414l-3 3a1 1 0 01-1.414 0l-3-3a1 1 0 010-1.414z"
                      clip-rule="evenodd" />
                  </svg>
                  Download File
                </a>
              </div>
            </div>
          </div>
          <div v-if="previewModal.item?.file_path?.length > 1" class="mt-3">
            <p class="mb-1 text-xs font-medium text-gray-600">Semua File:</p>
            <ul class="pl-4 space-y-1 list-disc">
              <li v-for="(fp, i) in previewModal.item.file_path" :key="i"><a :href="fp" target="_blank"
                  class="text-xs text-indigo-600 hover:underline">{{ fp }}</a></li>
            </ul>
          </div>
        </div>
      </div>

      <div v-if="moveModal.open" class="fixed inset-0 z-50 flex items-center justify-center bg-black/40">
        <div class="w-full max-w-lg p-4 bg-white rounded shadow">
          <div class="flex items-center justify-between mb-2">
            <h2 class="text-sm font-semibold">Pindahkan Item</h2>
            <button @click="closeMove" class="text-xs text-gray-500">Tutup</button>
          </div>
          <div class="overflow-auto max-h-80">
            <ul class="space-y-1 text-xs">
              <li><button @click="selectMoveTarget(null)" class="hover:underline"
                  :class="{ 'font-semibold': moveModal.target === null }">/ (Root)</button></li>
              <FolderNode v-for="node in moveModal.tree" :key="node.id" :node="node" :selected="moveModal.target"
                @select="selectMoveTarget" :current-id="moveModal.sourceId" />
            </ul>
          </div>
          <div class="flex justify-end gap-2 mt-3">
            <button @click="doMove" :disabled="moveModal.loading"
              class="px-3 py-1 text-xs font-semibold text-white bg-teal-600 rounded disabled:opacity-40">Pindahkan</button>
          </div>
        </div>
      </div>
      <!-- Version History Modal -->
      <div v-if="historyModal.open" class="fixed inset-0 z-50 flex items-center justify-center bg-black/40">
        <div class="w-full max-w-xl p-4 bg-white rounded shadow max-h-[80vh] overflow-auto">
          <div class="flex items-center justify-between mb-2">
            <h2 class="text-sm font-semibold">Riwayat Versi: {{ historyModal.currentName }}</h2>
            <button @click="closeHistory" class="text-xs text-gray-500">Tutup</button>
          </div>
          <div v-if="historyModal.loading" class="py-4 text-xs text-gray-500">Memuat...</div>
          <div v-else>
            <table class="w-full text-xs border">
              <thead class="bg-gray-50">
                <tr>
                  <th class="px-2 py-1 text-left">Versi</th>
                  <th class="px-2 py-1 text-left">Nama (Snapshot)</th>
                  <th class="px-2 py-1 text-left">Aksi</th>
                  <th class="px-2 py-1 text-left">Tanggal</th>
                  <th class="px-2 py-1 text-left">Restore</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="v in historyModal.items" :key="v.id" class="border-t">
                  <td class="px-2 py-1">{{ v.version }}</td>
                  <td class="px-2 py-1">{{ v.nama_dok }}</td>
                  <td class="px-2 py-1">{{ humanAction(v.action) }}</td>
                  <td class="px-2 py-1">{{ formatDate(v.created_at) }}</td>
                  <td class="px-2 py-1">
                    <div class="flex flex-col gap-1">
                      <button v-if="canRestore(v.action)" @click="restoreVersion(v.version)"
                        class="px-2 py-0.5 text-[10px] font-semibold text-white bg-amber-600 rounded hover:bg-amber-700">Restore</button>
                      <button @click="openDiff(v.version)"
                        class="px-2 py-0.5 text-[10px] font-semibold text-white bg-slate-600 rounded hover:bg-slate-700">Diff</button>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
            <p v-if="!historyModal.items.length" class="py-4 text-xs text-gray-500">Belum ada snapshot versi.</p>
            <div v-if="historyModal.meta && historyModal.meta.last_page > 1"
              class="flex items-center justify-between mt-3 text-[11px]">
              <div>Halaman {{ historyModal.meta.current_page }} / {{ historyModal.meta.last_page }}</div>
              <div class="flex items-center gap-2">
                <button @click="changeHistoryPage('prev')" :disabled="historyModal.meta.current_page === 1"
                  class="px-2 py-0.5 border rounded disabled:opacity-40">Prev</button>
                <button @click="changeHistoryPage('next')"
                  :disabled="historyModal.meta.current_page === historyModal.meta.last_page"
                  class="px-2 py-0.5 border rounded disabled:opacity-40">Next</button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Replace File Modal -->
      <div v-if="replaceModal.open" class="fixed inset-0 z-50 flex items-center justify-center bg-black/40">
        <div class="w-full max-w-md p-4 bg-white rounded shadow">
          <div class="flex items-center justify-between mb-2">
            <h2 class="text-sm font-semibold">Ganti File: {{ replaceModal.current?.nama_dok }}</h2>
            <button @click="closeReplace" class="text-xs text-gray-500">Tutup</button>
          </div>
          <div class="space-y-3 text-xs">
            <div>
              <label class="block mb-1 font-medium">Nama Baru (opsional)</label>
              <input type="text" v-model="replaceModal.form.nama_dok" class="w-full px-2 py-1 border rounded"
                placeholder="Biarkan kosong jika tidak diubah" />
            </div>
            <div>
              <label class="block mb-1 font-medium">Deskripsi (opsional)</label>
              <textarea rows="3" v-model="replaceModal.form.deskripsi" class="w-full px-2 py-1 border rounded"
                placeholder="Deskripsi baru / kosongkan"></textarea>
            </div>
            <div>
              <label class="block mb-1 font-medium">File Pengganti (boleh multi)</label>
              <input type="file" multiple @change="onReplaceFiles" class="w-full text-xs" />
            </div>
            <div>
              <label class="block mb-1 font-medium">Tags (pisah koma, opsional)</label>
              <input type="text" v-model="replaceModal.form.tags" class="w-full px-2 py-1 border rounded"
                placeholder="misal: revisi,final" />
            </div>
            <div class="flex justify-end gap-2 pt-2">
              <button @click="submitReplace" :disabled="replaceModal.loading"
                class="px-3 py-1 text-xs font-semibold text-white bg-purple-600 rounded disabled:opacity-40">Simpan</button>
            </div>
            <p v-if="replaceModal.error" class="text-[10px] text-red-600">{{ replaceModal.error }}</p>
            <p v-if="replaceModal.success" class="text-[10px] text-emerald-600">{{ replaceModal.success }}</p>
          </div>
        </div>
      </div>

      <!-- Diff Modal -->
      <div v-if="diffModal.open" class="fixed inset-0 z-50 flex items-center justify-center bg-black/40">
        <div class="w-full max-w-lg p-4 bg-white rounded shadow max-h-[80vh] overflow-auto text-xs">
          <div class="flex items-center justify-between mb-2">
            <h2 class="text-sm font-semibold">Diff Versi #{{ diffModal.version }}</h2>
            <button @click="closeDiff" class="text-xs text-gray-500">Tutup</button>
          </div>
          <div v-if="diffModal.loading" class="py-4 text-gray-500">Memuat diff...</div>
          <div v-else-if="!diffModal.data" class="py-4 text-gray-500">Tidak ada data diff.</div>
          <div v-else>
            <div class="space-y-2">
              <div><span class="font-semibold">Action:</span> {{ diffModal.data.action }}</div>
              <div v-if="diffModal.data.diff.type === 'name'">
                <p><span class="font-semibold">Snapshot Name:</span> {{ diffModal.data.diff.snapshot }}</p>
                <p><span class="font-semibold">Current Name:</span> {{ diffModal.data.diff.current }}</p>
                <p><span class="font-semibold">Changed:</span> {{ diffModal.data.diff.changed ? 'Ya' : 'Tidak' }}</p>
              </div>
              <div v-else-if="diffModal.data.diff.type === 'parent'">
                <p><span class="font-semibold">Snapshot Parent ID:</span> {{ diffModal.data.diff.snapshot_parent ??
                  'Root' }}
                </p>
                <p><span class="font-semibold">Current Parent ID:</span> {{ diffModal.data.diff.current_parent ?? 'Root'
                  }}
                </p>
                <p><span class="font-semibold">Changed:</span> {{ diffModal.data.diff.changed ? 'Ya' : 'Tidak' }}</p>
              </div>
              <div v-else-if="diffModal.data.diff.type === 'files'">
                <p class="font-semibold">Perubahan File:</p>
                <div class="grid grid-cols-2 gap-3">
                  <div>
                    <p class="mb-1 font-medium">Snapshot Files</p>
                    <ul class="pl-4 space-y-1 overflow-auto list-disc max-h-40">
                      <li v-for="(f, i) in diffModal.data.diff.snapshot_files" :key="'s' + i">{{ f }}</li>
                    </ul>
                  </div>
                  <div>
                    <p class="mb-1 font-medium">Current Files</p>
                    <ul class="pl-4 space-y-1 overflow-auto list-disc max-h-40">
                      <li v-for="(f, i) in diffModal.data.diff.current_files" :key="'c' + i">{{ f }}</li>
                    </ul>
                  </div>
                </div>
                <div class="mt-2">
                  <p><span class="font-semibold">Removed:</span> <span
                      v-if="!diffModal.data.diff.removed.length">-</span></p>
                  <ul v-if="diffModal.data.diff.removed.length" class="pl-4 mb-2 space-y-1 list-disc">
                    <li v-for="(f, i) in diffModal.data.diff.removed" :key="'r' + i">{{ f }}</li>
                  </ul>
                  <p><span class="font-semibold">Added:</span> <span v-if="!diffModal.data.diff.added.length">-</span>
                  </p>
                  <ul v-if="diffModal.data.diff.added.length" class="pl-4 space-y-1 list-disc">
                    <li v-for="(f, i) in diffModal.data.diff.added" :key="'a' + i">{{ f }}</li>
                  </ul>
                  <p><span class="font-semibold">Changed:</span> {{ diffModal.data.diff.changed ? 'Ya' : 'Tidak' }}</p>
                </div>
              </div>
              <div v-else>
                <p>Tidak ada diff khusus yang dapat dihitung untuk action ini.</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Trash Modal -->
      <div v-if="trashModal.open" class="fixed inset-0 z-50 flex items-center justify-center bg-black/40">
        <div class="w-full max-w-xl p-4 bg-white rounded shadow max-h-[80vh] overflow-auto text-xs">
          <div class="flex items-center justify-between mb-2">
            <h2 class="text-sm font-semibold">Trash (Soft Deleted)</h2>
            <button @click="closeTrash" class="text-xs text-gray-500">Tutup</button>
          </div>
          <div v-if="trashModal.loading" class="py-4 text-gray-500">Memuat...</div>
          <div v-else>
            <p v-if="trashModal.error" class="mb-2 text-red-600">{{ trashModal.error }}</p>
            <table class="w-full text-xs border">
              <thead class="bg-gray-50">
                <tr>
                  <th class="px-2 py-1 text-left">Nama</th>
                  <th class="px-2 py-1 text-left">Tipe</th>
                  <th class="px-2 py-1 text-left">Deleted At</th>
                  <th class="px-2 py-1 text-left">Aksi</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="it in trashModal.items" :key="it.id" class="border-t">
                  <td class="px-2 py-1">{{ it.nama_dok }}</td>
                  <td class="px-2 py-1">{{ it.is_folder ? 'Folder' : 'File' }}</td>
                  <td class="px-2 py-1">{{ formatDate(it.deleted_at) }}</td>
                  <td class="px-2 py-1">
                    <div class="flex gap-2">
                      <button @click="restoreTrash(it.id)"
                        class="px-2 py-0.5 text-[10px] font-semibold text-white bg-emerald-600 rounded hover:bg-emerald-700">Restore</button>
                      <button @click="forceDeleteTrash(it.id)"
                        class="px-2 py-0.5 text-[10px] font-semibold text-white bg-red-600 rounded hover:bg-red-700">Delete</button>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
            <p v-if="!trashModal.items.length" class="py-4 text-gray-500">Trash kosong.</p>
          </div>
        </div>
      </div>
    </template>
  </Container>
</template>

<script setup>
import { defineProps, watch, ref, computed, onMounted, nextTick, toRefs, onBeforeUnmount } from "vue";
import { Head } from "@inertiajs/vue3";
import Container from "@/Layouts/Container.vue";
import Header from "@/Components/Header.vue";
import FormAdd from "@/Components/AuditMutu/FormAddDokumen.vue";
import Breadcrumbs from "@/Components/Breadcrumbs.vue";
import { router } from '@inertiajs/vue3';
import Swal from 'sweetalert2';

const props = defineProps({
  standar: { type: Object, required: true },
  files: { type: Object, required: true },
  programs: { type: Object, required: true },
  folders: { type: Array, default: () => [] },
  currentFolder: { type: Object, default: null },
  folderTrail: { type: Array, default: () => [] },
  highlight: { type: String, default: null },
  availableTags: { type: Array, default: () => [] },
  filters: { type: Object, default: () => ({}) }
})
// Extract reactive ref for folders so existing watchers using folders.value work and template can use 'folders'
const { folders } = toRefs(props)
const highlightId = ref(props.highlight)
onMounted(() => {
  if (highlightId.value) {
    nextTick(() => {
      const row = document.querySelector(`[data-iddok="${highlightId.value}"]`)
      if (row) {
        row.classList.add('animate-highlight')
        row.scrollIntoView({ behavior: 'smooth', block: 'center' })
        setTimeout(() => row.classList.remove('animate-highlight'), 4000)
      }
    })
  }
})

// Per-row dropdown menu state for file actions
const openMenuFor = ref(null)
const toggleMenu = (id) => {
  openMenuFor.value = openMenuFor.value === id ? null : id
}
const closeMenu = () => { openMenuFor.value = null }
const onGlobalClick = () => { closeMenu() }
const onEsc = (e) => { if (e.key === 'Escape') closeMenu() }

onMounted(() => {
  window.addEventListener('click', onGlobalClick)
  window.addEventListener('keydown', onEsc)
})
onBeforeUnmount(() => {
  window.removeEventListener('click', onGlobalClick)
  window.removeEventListener('keydown', onEsc)
})

const isModalOpen = ref(false);
const isModalFile = ref(false);
const viewdokumen = ref(null);
const selectedJenis = ref(null);
const selectedProdi = ref(null);

const editDokumen = async (iddok) => {
  try {
    const response = await fetch(`/viewdockinerja/${iddok}`);
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const data = await response.json();
    viewdokumen.value = data.dokumen;
    selectedJenis.value = data.jenis;
    selectedProdi.value = data.prodis;
    isModalOpen.value = true;
  } catch (error) {
    console.error("Error fetching data:", error.message);
  }
};
const editFile = async (iddok) => {
  try {
    const response = await fetch(`/viewdockinerja/${iddok}`);
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const data = await response.json();
    viewdokumen.value = data.dokumen;
    selectedJenis.value = data.jenis;
    isModalFile.value = true;
  } catch (error) {
    console.error("Error fetching data:", error.message);
  }
};
// Check if file is an image
function isImage(filePath) {
  return /\.(jpg|jpeg|png|gif|bmp|webp)$/i.test(filePath);
}

// Check if file is a PDF
function isPdf(filePath) {
  return /\.pdf$/i.test(filePath);
}

// Check if file is Excel
function isExcel(filePath) {
  return /\.(xls|xlsx|xlsm|xlsb)$/i.test(filePath);
}

// Check if file is Word Document
function isWord(filePath) {
  return /\.(doc|docx|docm)$/i.test(filePath);
}

// Check if file is PowerPoint
function isPowerPoint(filePath) {
  return /\.(ppt|pptx|pptm)$/i.test(filePath);
}

// Check if file is Text/CSV
function isTextFile(filePath) {
  return /\.(txt|csv|json|xml|md|log|sql|ini|conf|cfg)$/i.test(filePath);
}

// Check if file is Archive
function isArchive(filePath) {
  return /\.(zip|rar|7z|tar|gz|bz2)$/i.test(filePath);
}

// Check if file is Video
function isVideo(filePath) {
  return /\.(mp4|avi|mov|wmv|flv|webm|mkv)$/i.test(filePath);
}

// Check if file is Audio
function isAudio(filePath) {
  return /\.(mp3|wav|flac|aac|ogg|wma)$/i.test(filePath);
}

// Get file extension
function getFileExtension(filePath) {
  return filePath.split('.').pop().toLowerCase();
}

// Get file type icon and color
function getFileTypeInfo(filePath) {
  const ext = getFileExtension(filePath);
  const types = {
    // Office Files
    'xlsx': { color: 'text-green-600', bg: 'bg-green-50', border: 'border-green-200', name: 'Excel' },
    'xls': { color: 'text-green-600', bg: 'bg-green-50', border: 'border-green-200', name: 'Excel' },
    'docx': { color: 'text-blue-600', bg: 'bg-blue-50', border: 'border-blue-200', name: 'Word' },
    'doc': { color: 'text-blue-600', bg: 'bg-blue-50', border: 'border-blue-200', name: 'Word' },
    'pptx': { color: 'text-orange-600', bg: 'bg-orange-50', border: 'border-orange-200', name: 'PowerPoint' },
    'ppt': { color: 'text-orange-600', bg: 'bg-orange-50', border: 'border-orange-200', name: 'PowerPoint' },
    // PDF
    'pdf': { color: 'text-red-600', bg: 'bg-red-50', border: 'border-red-200', name: 'PDF' },
    // Images
    'jpg': { color: 'text-purple-600', bg: 'bg-purple-50', border: 'border-purple-200', name: 'Image' },
    'jpeg': { color: 'text-purple-600', bg: 'bg-purple-50', border: 'border-purple-200', name: 'Image' },
    'png': { color: 'text-purple-600', bg: 'bg-purple-50', border: 'border-purple-200', name: 'Image' },
    'gif': { color: 'text-purple-600', bg: 'bg-purple-50', border: 'border-purple-200', name: 'Image' },
    // Text files
    'txt': { color: 'text-gray-600', bg: 'bg-gray-50', border: 'border-gray-200', name: 'Text' },
    'csv': { color: 'text-green-600', bg: 'bg-green-50', border: 'border-green-200', name: 'CSV' },
    'json': { color: 'text-yellow-600', bg: 'bg-yellow-50', border: 'border-yellow-200', name: 'JSON' },
    'xml': { color: 'text-red-600', bg: 'bg-red-50', border: 'border-red-200', name: 'XML' },
    'sql': { color: 'text-blue-600', bg: 'bg-blue-50', border: 'border-blue-200', name: 'SQL' },
    // Archive files
    'zip': { color: 'text-indigo-600', bg: 'bg-indigo-50', border: 'border-indigo-200', name: 'ZIP' },
    'rar': { color: 'text-indigo-600', bg: 'bg-indigo-50', border: 'border-indigo-200', name: 'RAR' },
    '7z': { color: 'text-indigo-600', bg: 'bg-indigo-50', border: 'border-indigo-200', name: '7Z' },
    'tar': { color: 'text-indigo-600', bg: 'bg-indigo-50', border: 'border-indigo-200', name: 'TAR' },
    // Media files
    'mp4': { color: 'text-pink-600', bg: 'bg-pink-50', border: 'border-pink-200', name: 'Video' },
    'avi': { color: 'text-pink-600', bg: 'bg-pink-50', border: 'border-pink-200', name: 'Video' },
    'mp3': { color: 'text-teal-600', bg: 'bg-teal-50', border: 'border-teal-200', name: 'Audio' },
    'wav': { color: 'text-teal-600', bg: 'bg-teal-50', border: 'border-teal-200', name: 'Audio' },
  };

  return types[ext] || { color: 'text-gray-400', bg: 'bg-gray-50', border: 'border-gray-200', name: ext.toUpperCase() };
}

// Check if file can be previewed
function canPreview(filePath) {
  return isImage(filePath) || isPdf(filePath) || isExcel(filePath) ||
    isWord(filePath) || isPowerPoint(filePath) || isTextFile(filePath) ||
    isArchive(filePath) || isVideo(filePath) || isAudio(filePath);
}

const changePage = (link) => {
  if (!link.url || link.active) return;
  router.visit(link.url, {
    preserveScroll: true,
    preserveState: true,
    replace: true,
  });
};

const sanitizeLabel = (label) => {
  return label
    .replace('&laquo;', '«')
    .replace('&raquo;', '»')
    .replace('Previous', 'Prev')
    .replace('Next', 'Next');
}

// Support both paginator root object (files.data, files.links, files.total) and resource collection wrapper
// If backend returns a Laravel paginator passed through a Resource::collection(), the structure might be:
// files.data: array of items
// files.meta / files.links (JSON resource style) OR direct files.links (paginator to Inertia)

const pageCount = computed(() => {
  if (props.files?.data) return props.files.data.length
  return 0
})
const totalDocs = computed(() => {
  if (typeof props.files?.total === 'number') return props.files.total
  // JSON resource style meta.total
  if (props.files?.meta?.total) return props.files.meta.total
  return props.files?.data?.length || 0
})
const paginationLinks = computed(() => {
  // Inertia paginator style
  if (Array.isArray(props.files?.links)) return props.files.links
  // JSON resource style: links array inside meta/links pairing
  if (Array.isArray(props.files?.meta?.links)) return props.files.meta.links
  return []
})

// Folder breadcrumb computed (ensure order)
const folderBreadcrumbs = computed(() => {
  return props.folderTrail || []
})

// New folder creation state
const newFolderName = ref('')
const creatingFolder = ref(false)
const folderError = ref('')

// Combined create folder + upload file state
const combo = ref({ folder: '', fileName: '', deskripsi: '', file: null, tags: '', loading: false, error: '', success: '' })
const comboFileInput = ref(null)
const onComboFileChange = (e) => {
  combo.value.file = e.target.files && e.target.files[0] ? e.target.files[0] : null
}
const createFolderWithFile = async () => {
  combo.value.error = ''; combo.value.success = ''
  if (!combo.value.folder.trim()) { combo.value.error = 'Nama folder wajib'; return }
  combo.value.loading = true
  try {
    const formData = new FormData()
    formData.append('stdid', props.standar.data[0].id)
    if (props.currentFolder?.id) formData.append('parent_id', props.currentFolder.id)
    formData.append('folder_name', combo.value.folder.trim())
    if (combo.value.fileName.trim()) formData.append('file_nama', combo.value.fileName.trim())
    if (combo.value.deskripsi.trim()) formData.append('file_deskripsi', combo.value.deskripsi.trim())
    if (combo.value.file) formData.append('file', combo.value.file)
    if (combo.value.tags.trim()) {
      combo.value.tags.split(',').map(t => t.trim()).filter(t => t.length).forEach(t => formData.append('tags[]', t))
    }
    await router.post(route('auditmutu.folder.storeWithFile'), formData, {
      forceFormData: true,
      preserveScroll: true,
      onSuccess: () => {
        combo.value.success = 'Berhasil disimpan';
        combo.value.folder = ''; combo.value.fileName = ''; combo.value.deskripsi = ''; combo.value.tags = ''; combo.value.file = null
        if (comboFileInput.value) comboFileInput.value.value = ''
      },
      onError: errs => { combo.value.error = Object.values(errs)[0] || 'Gagal menyimpan' },
      onFinish: () => { combo.value.loading = false }
    })
  } catch (e) {
    combo.value.error = e.message
    combo.value.loading = false
  }
}

const createFolder = async () => {
  folderError.value = ''
  if (!newFolderName.value.trim()) return
  creatingFolder.value = true
  try {
    await router.post(route('auditmutu.folder.store'), {
      nama_dok: newFolderName.value.trim(),
      parent_id: props.currentFolder?.id || null,
      stdid: props.standar.data[0].id,
    }, {
      preserveScroll: true,
      onSuccess: () => {
        newFolderName.value = ''
      },
      onError: (errs) => {
        folderError.value = errs.nama_dok || 'Gagal membuat folder'
      },
      onFinish: () => {
        creatingFolder.value = false
      }
    })
  } catch (e) {
    folderError.value = e.message
    creatingFolder.value = false
  }
}

const nestedPath = ref('')
const creatingNested = ref(false)
const nestedError = ref('')

const createNestedPath = async () => {
  nestedError.value = ''
  if (!nestedPath.value.trim()) return
  creatingNested.value = true
  try {
    await router.post(route('auditmutu.folder.store'), {
      path: nestedPath.value.trim(),
      parent_id: props.currentFolder?.id || null,
      stdid: props.standar.data[0].id,
      nama_dok: 'placeholder' // validated but ignored when path present
    }, {
      preserveScroll: true,
      onSuccess: () => { nestedPath.value = '' },
      onError: errs => { nestedError.value = errs.path || errs.nama_dok || 'Gagal membuat path' },
      onFinish: () => { creatingNested.value = false }
    })
  } catch (e) {
    nestedError.value = e.message
    creatingNested.value = false
  }
}

const navigateToFolder = (id) => {
  router.visit(route('auditmutu.adddocument', props.standar.data[0].slug), {
    method: 'get',
    data: {
      folder: id,
      search: localSearch.value || undefined,
      per_page: pageSize.value,
    },
    preserveScroll: true,
    preserveState: true,
    replace: true,
  })
}

const goToRoot = () => {
  router.visit(route('auditmutu.adddocument', props.standar.data[0].slug), {
    method: 'get',
    data: {
      search: localSearch.value || undefined,
      per_page: pageSize.value,
    },
    preserveScroll: true,
    preserveState: true,
    replace: true,
  })
}

// Preview modal state
const previewModal = ref({ open: false, item: null, primaryFile: null })
const showOfficePreview = ref(false)
const openPreview = async (id) => {
  try {
    const res = await fetch(route('auditmutu.repository.show', id))
    if (!res.ok) return
    const data = await res.json()
    previewModal.value.item = data
    previewModal.value.primaryFile = data.file_path && data.file_path.length ? data.file_path[0] : null
    previewModal.value.open = true
  } catch (e) { console.error(e) }
}
const closePreview = () => {
  previewModal.value.open = false
  showOfficePreview.value = false
  showTextPreview.value = false
  textPreview.value = { loading: false, content: '', error: '' }
}

// Computed PDF src: prefer backend streaming endpoint to ensure inline headers
const pdfSrc = computed(() => {
  const primary = previewModal.value?.primaryFile || ''
  const id = previewModal.value?.item?.id
  if (id && primary && isPdf(primary)) {
    try {
      return route('auditmutu.repository.stream', id) + '?file=0'
    } catch {
      // Fallback to original URL with viewer hint
      return primary.includes('#') ? primary : `${primary}#toolbar=0&navpanes=0&scrollbar=1`
    }
  }
  return primary || null
})

// Computed Image src: prefer backend streaming endpoint to ensure consistent headers
const imageSrc = computed(() => {
  const primary = previewModal.value?.primaryFile || ''
  const id = previewModal.value?.item?.id
  if (id && primary && isImage(primary)) {
    try {
      return route('auditmutu.repository.stream', id) + '?file=0'
    } catch {
      return primary
    }
  }
  return primary || null
})

// Rename inline state
const renameState = ref({ type: null, id: null, name: '' })
const startRename = (type, id, currentName) => {
  renameState.value = { type, id, name: currentName }
}
const isRenaming = (type, id) => renameState.value.type === type && renameState.value.id === id
const cancelRename = () => { renameState.value = { type: null, id: null, name: '' } }
const confirmRename = async (id, isFolder) => {
  try {
    await router.post(route('auditmutu.rename', id), { nama_dok: renameState.value.name }, {
      preserveScroll: true,
      onFinish: () => cancelRename()
    })
  } catch (e) { console.error(e) }
}

// Export folder as ZIP
const exportFolder = async (id) => {
  try {
    const url = route('auditmutu.export.zip', id)
    // Trigger download via hidden link
    const a = document.createElement('a')
    a.href = url
    a.setAttribute('download', '')
    document.body.appendChild(a)
    a.click()
    setTimeout(() => { document.body.removeChild(a) }, 1000)
  } catch (e) { console.error(e) }
}

// Version history modal
const historyModal = ref({ open: false, repoId: null, items: [], currentName: '', loading: false, page: 1, perPage: 10, meta: null, links: null })
const fetchHistory = async () => {
  if (!historyModal.value.repoId) return
  historyModal.value.loading = true
  try {
    const url = route('auditmutu.versions', historyModal.value.repoId) + `?page=${historyModal.value.page}&per_page=${historyModal.value.perPage}`
    const res = await fetch(url)
    if (res.ok) {
      const data = await res.json()
      historyModal.value.items = data.versions || []
      historyModal.value.currentName = data.current?.nama_dok || ''
      historyModal.value.meta = data.meta
      historyModal.value.links = data.links
    }
  } catch (e) { console.error(e) }
  finally { historyModal.value.loading = false }
}
const openHistory = async (id) => {
  historyModal.value.open = true
  historyModal.value.repoId = id
  historyModal.value.items = []
  historyModal.value.page = 1
  await fetchHistory()
}
const changeHistoryPage = async (dir) => {
  if (dir === 'prev' && historyModal.value.meta?.current_page > 1) {
    historyModal.value.page--
    await fetchHistory()
  } else if (dir === 'next' && historyModal.value.meta && historyModal.value.meta.current_page < historyModal.value.meta.last_page) {
    historyModal.value.page++
    await fetchHistory()
  }
}
const closeHistory = () => { historyModal.value.open = false }
const restoreVersion = async (version) => {
  if (!historyModal.value.repoId) return
  try {
    const res = await fetch(route('auditmutu.versions.restore', { repository: historyModal.value.repoId, version }), {
      method: 'POST',
      headers: { 'X-CSRF-TOKEN': document.querySelector('meta[name=csrf-token]')?.getAttribute('content') }
    })
    if (res.ok) {
      // refresh page to reflect new name
      applyFilters()
      openHistory(historyModal.value.repoId) // reload versions list
    }
  } catch (e) { console.error(e) }
}
const formatDate = (iso) => {
  if (!iso) return ''
  try { return new Date(iso).toLocaleString() } catch { return iso }
}

// Delete
const confirmDelete = (id) => {
  Swal.fire({
    title: 'Hapus?',
    text: 'Tindakan ini tidak bisa dibatalkan.',
    icon: 'warning',
    showCancelButton: true,
    confirmButtonText: 'Ya, hapus',
    cancelButtonText: 'Batal'
  }).then(result => {
    if (result.isConfirmed) {
      router.delete(route('auditmutu.delete', id), { preserveScroll: true })
    }
  })
}

// Move modal
const moveModal = ref({ open: false, sourceId: null, tree: [], target: null, loading: false })
const openMove = async (id) => {
  moveModal.value.open = true
  moveModal.value.sourceId = id
  moveModal.value.loading = true
  try {
    const res = await fetch(route('auditmutu.folder.tree', { stdid: props.standar.data[0].id }))
    const data = await res.json()
    moveModal.value.tree = data
  } catch (e) { console.error(e) }
  finally { moveModal.value.loading = false }
}
const closeMove = () => { moveModal.value.open = false }
const selectMoveTarget = (id) => { moveModal.value.target = id }
const singleMove = async () => {
  if (moveModal.value.sourceId == null) return
  if (moveModal.value.sourceId == moveModal.value.target) return
  await router.post(route('auditmutu.move', moveModal.value.sourceId), { target_folder_id: moveModal.value.target }, {
    preserveScroll: true,
    onFinish: () => closeMove()
  })
}

// Recursive folder node component (inline definition)
const FolderNode = {
  name: 'FolderNode',
  props: ['node', 'selected', 'currentId'],
  emits: ['select'],
  data() { return { open: false } },
  computed: { isDisabled() { return this.currentId === this.node.id } },
  template: `<li>
    <div class='flex items-center gap-1'>
      <button type='button' @click='open=!open' v-if='node.children.length' class='text-[10px] px-1 border rounded'>{{ open ? '-' : '+' }}</button>
      <button type='button' :disabled='isDisabled' @click="$emit('select', node.id)" :class="[ 'hover:underline', selected===node.id ? 'font-semibold' : '', isDisabled ? 'opacity-40 cursor-not-allowed' : '' ]">{{ node.nama_dok }}</button>
    </div>
    <ul v-show='open' class='pl-4 mt-1 space-y-1' v-if='node.children.length'>
      <FolderNode v-for='c in node.children' :key='c.id' :node='c' :selected='selected' @select="$emit('select',$event)" :current-id='currentId' />
    </ul>
  </li>`
}

// TagList component inline
const TagList = {
  name: 'TagList',
  props: { repositoryId: { type: Number, required: true }, initial: { type: Array, default: () => [] } },
  setup(props) {
    const tags = ref(props.initial)
    const editing = ref(false)
    const inputVal = ref('')
    const loading = ref(false)
    const addTag = async () => {
      const raw = inputVal.value.trim()
      if (!raw) return
      const list = [...tags.value.map(t => t.name), raw]
      await sync(list)
      inputVal.value = ''
    }
    const removeTag = async (name) => {
      const list = tags.value.filter(t => t.name !== name).map(t => t.name)
      await sync(list)
    }
    const sync = async (names) => {
      loading.value = true
      try {
        const res = await fetch(route('auditmutu.tags.sync', props.repositoryId), {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'X-CSRF-TOKEN': document.querySelector('meta[name=csrf-token]')?.getAttribute('content') },
          body: JSON.stringify({ tags: names })
        })
        if (res.ok) {
          tags.value = names.map(n => ({ name: n }))
        }
      } finally { loading.value = false }
    }
    return { tags, editing, inputVal, addTag, removeTag, loading }
  },
  template: `<div class='flex items-center gap-1 flex-wrap max-w-[180px]'>
    <template v-for='t in tags' :key='t.name'>
      <span class='px-1.5 py-0.5 bg-indigo-100 text-indigo-700 rounded text-[10px] flex items-center gap-1'>{{ t.name }} <button type='button' @click='removeTag(t.name)' class='text-[9px] hover:text-red-600'>&times;</button></span>
    </template>
    <template v-if='editing'>
      <input v-model='inputVal' @keyup.enter='addTag' type='text' class='px-1 py-0.5 border rounded text-[10px] w-20' placeholder='tag' />
      <button type='button' @click='addTag' class='text-[10px] text-indigo-600'>Add</button>
      <button type='button' @click='editing=false' class='text-[10px] text-gray-500'>Done</button>
    </template>
    <button v-else type='button' @click='editing=true' class='text-[10px] text-indigo-600'>+Tag</button>
    <span v-if='loading' class='text-[9px] text-gray-400'>...</span>
  </div>`
}

// Multi-select state
const selectedItems = ref([])
const allSelected = ref(false)
watch(selectedItems, () => {
  // reset master checkbox if mismatch
  const total = folders.value?.length + (props.files?.data?.length || 0)
  allSelected.value = selectedItems.value.length && selectedItems.value.length === total
})
const toggleSelectAll = () => {
  if (allSelected.value) {
    // select everything
    const all = []
    folders.value.forEach(f => all.push({ id: f.id, type: 'folder' }))
    props.files.data.forEach(f => all.push({ id: f.id, type: 'file' }))
    selectedItems.value = all
  } else {
    selectedItems.value = []
  }
}
const clearSelection = () => { selectedItems.value = []; allSelected.value = false }
const openBulkMove = () => {
  // open move modal; we will treat as multi-source sequential move
  if (!selectedItems.value.length) return
  moveModal.value.open = true
  moveModal.value.sourceId = null // multi mode
  moveModal.value.loading = true
  fetch(route('auditmutu.folder.tree', { stdid: props.standar.data[0].id }))
    .then(r => r.json())
    .then(data => moveModal.value.tree = data)
    .finally(() => moveModal.value.loading = false)
}
const bulkDelete = () => {
  if (!selectedItems.value.length) return
  Swal.fire({
    title: 'Hapus banyak item?',
    text: 'Semua item terpilih akan dihapus.',
    icon: 'warning',
    showCancelButton: true,
    confirmButtonText: 'Hapus',
    cancelButtonText: 'Batal'
  }).then(async res => {
    if (!res.isConfirmed) return
    for (const it of selectedItems.value) {
      await router.delete(route('auditmutu.delete', it.id), { preserveScroll: true, preserveState: true })
    }
    clearSelection()
  })
}
// Override doMove for multi-select support
const doMove = async () => {
  // single move
  if (moveModal.value.sourceId) {
    return singleMove()
  }
  // bulk move
  if (moveModal.value.target === undefined) return
  for (const it of selectedItems.value) {
    await router.post(route('auditmutu.move', it.id), { target_folder_id: moveModal.value.target }, { preserveScroll: true, preserveState: true })
  }
  closeMove(); clearSelection()
}


// Filter state (hydrated from server-provided filters if available)
const localSearch = ref((props.filters && props.filters.search) || '')
const pageSize = ref((props.filters && props.filters.per_page) || 10)
// Tag filter state
const selectedTags = ref(props.filters?.tags || [])
const toggleTag = (slug) => {
  const idx = selectedTags.value.findIndex(t => t === slug)
  if (idx >= 0) {
    selectedTags.value.splice(idx, 1)
  } else {
    selectedTags.value.push(slug)
  }
  applyFilters()
}
const clearTags = () => { selectedTags.value = []; applyFilters() }

const applyFilters = () => {
  router.visit(route('auditmutu.adddocument', props.standar.data[0].slug), {
    method: 'get',
    data: {
      search: localSearch.value || undefined,
      per_page: pageSize.value,
      tags: selectedTags.value.length ? selectedTags.value.join(',') : undefined,
      folder: props.currentFolder?.id || undefined,
    },
    replace: true,
    preserveState: true,
    preserveScroll: true,
  })
}
const resetFilters = () => {
  localSearch.value = ''
  applyFilters()
}

// Auto reset ketika input pencarian dikosongkan tanpa harus klik tombol
let searchClearTimer = null
watch(localSearch, (val, old) => {
  if (val === '' && old && old.length > 0) {
    if (searchClearTimer) clearTimeout(searchClearTimer)
    searchClearTimer = setTimeout(() => {
      // Pastikan tidak ada nilai tertinggal
      applyFilters()
    }, 300) // debounce agar tidak terlalu sering reload saat user menahan backspace
  }
})

const dragState = ref({ draggingId: null, isFolder: false, overFolderId: null })

const onDragStart = (id, isFolder) => {
  dragState.value.draggingId = id
  dragState.value.isFolder = isFolder
}
const onDragOverFolder = (folderId) => {
  if (dragState.value.draggingId === folderId) return
  dragState.value.overFolderId = folderId
  highlightFolderRow(folderId, true)
}
const onDragLeaveFolder = (folderId) => {
  if (dragState.value.overFolderId === folderId) {
    dragState.value.overFolderId = null
    highlightFolderRow(folderId, false)
  }
}
const onDropOnFolder = async (targetFolderId) => {
  if (dragState.value.draggingId == null) return
  const movingId = dragState.value.draggingId
  dragState.value.overFolderId = null
  highlightFolderRow(targetFolderId, false)
  // If user dragged multiple selected and the dragged item is in selection, move all selected
  const bulk = selectedItems.value.find(it => it.id === movingId) ? selectedItems.value.slice() : [{ id: movingId, type: dragState.value.isFolder ? 'folder' : 'file' }]
  for (const it of bulk) {
    if (it.id === targetFolderId) continue // skip self
    await router.post(route('auditmutu.move', it.id), { target_folder_id: targetFolderId }, { preserveScroll: true, preserveState: true })
  }
  clearSelection()
  dragState.value.draggingId = null
}
function highlightFolderRow(folderId, on) {
  const row = document.querySelector(`[data-folder-row='${folderId}']`)
  if (row) {
    if (on) {
      row.classList.add('ring-2', 'ring-indigo-400')
    } else {
      row.classList.remove('ring-2', 'ring-indigo-400')
    }
  }
}

const replaceModal = ref({ open: false, current: null, files: [], form: { nama_dok: '', deskripsi: '', tags: '' }, loading: false, error: '', success: '' })
const openReplace = (item) => {
  replaceModal.value.open = true
  replaceModal.value.current = item
  replaceModal.value.files = []
  replaceModal.value.form = { nama_dok: '', deskripsi: '', tags: '' }
  replaceModal.value.error = ''; replaceModal.value.success = ''
}
const closeReplace = () => { replaceModal.value.open = false }
const onReplaceFiles = (e) => { replaceModal.value.files = Array.from(e.target.files || []) }
const submitReplace = async () => {
  if (!replaceModal.value.current) return
  replaceModal.value.error = ''; replaceModal.value.success = ''; replaceModal.value.loading = true
  try {
    const fd = new FormData()
    if (replaceModal.value.form.nama_dok.trim()) fd.append('nama_dok', replaceModal.value.form.nama_dok.trim())
    if (replaceModal.value.form.deskripsi.trim()) fd.append('deskripsi', replaceModal.value.form.deskripsi.trim())
    replaceModal.value.files.forEach((f, i) => fd.append(`files[${i}]`, f))
    if (replaceModal.value.form.tags.trim()) {
      replaceModal.value.form.tags.split(',').map(t => t.trim()).filter(t => t.length).forEach(t => fd.append('tags[]', t))
    }
    const res = await fetch(route('auditmutu.replace', replaceModal.value.current.id), { method: 'POST', headers: { 'X-CSRF-TOKEN': document.querySelector('meta[name=csrf-token]')?.getAttribute('content') }, body: fd })
    if (!res.ok) throw new Error('Gagal mengganti file')
    replaceModal.value.success = 'Berhasil diganti'
    // refresh listing
    applyFilters()
  } catch (e) {
    replaceModal.value.error = e.message
  } finally { replaceModal.value.loading = false }
}

const humanAction = (act) => {
  switch (act) {
    case 'rename_before': return 'Sebelum Rename';
    case 'restore_before': return 'Sebelum Restore Rename';
    case 'move_before': return 'Sebelum Pindah Folder';
    case 'move_restore_before': return 'Sebelum Restore Pindah';
    case 'replace_file_before': return 'Sebelum Ganti File';
    case 'replace_restore_before': return 'Sebelum Restore File';
    default: return act;
  }
}
const canRestore = (act) => ['rename_before', 'move_before', 'replace_file_before'].includes(act)

// Diff modal state & logic
const diffModal = ref({ open: false, loading: false, data: null, version: null })
const openDiff = async (version) => {
  if (!historyModal.value.repoId) return
  diffModal.value.open = true
  diffModal.value.loading = true
  diffModal.value.version = version
  diffModal.value.data = null
  try {
    const url = route('auditmutu.versions.diff', { repository: historyModal.value.repoId, version })
    const res = await fetch(url)
    if (res.ok) {
      diffModal.value.data = await res.json()
    }
  } catch (e) { console.error(e) }
  finally { diffModal.value.loading = false }
}
const closeDiff = () => { diffModal.value.open = false }

// Trash (Soft Deleted) modal
const trashModal = ref({ open: false, loading: false, items: [], error: '' })
const openTrash = async () => {
  trashModal.value.open = true
  await fetchTrash()
}
const closeTrash = () => { trashModal.value.open = false }
const fetchTrash = async () => {
  trashModal.value.loading = true; trashModal.value.error = '';
  try {
    const url = route('auditmutu.trashed', { stdid: props.standar.data[0].id })
    const res = await fetch(url)
    if (!res.ok) throw new Error('Gagal memuat trash')
    const data = await res.json()
    trashModal.value.items = data.data || []
  } catch (e) { trashModal.value.error = e.message }
  finally { trashModal.value.loading = false }
}
const restoreTrash = async (id) => {
  try {
    const res = await fetch(route('auditmutu.trashed.restore', id), { method: 'POST', headers: { 'X-CSRF-TOKEN': document.querySelector('meta[name=csrf-token]')?.getAttribute('content') } })
    if (!res.ok) throw new Error('Gagal restore')
    await fetchTrash(); applyFilters()
  } catch (e) { alert(e.message) }
}
const forceDeleteTrash = async (id) => {
  if (!confirm('Hapus permanen item ini?')) return
  try {
    const res = await fetch(route('auditmutu.trashed.force', id), { method: 'DELETE', headers: { 'X-CSRF-TOKEN': document.querySelector('meta[name=csrf-token]')?.getAttribute('content') } })
    if (!res.ok) throw new Error('Gagal hapus permanen')
    await fetchTrash()
  } catch (e) { alert(e.message) }
}

// Method untuk membuka Office Online viewer
const openOfficeOnline = (type) => {
  const fileUrl = encodeURIComponent(previewModal.value.primaryFile)
  let viewerUrl = '';

  switch (type) {
    case 'excel':
      // Microsoft Office Online Excel Viewer
      viewerUrl = `https://view.officeapps.live.com/op/embed.aspx?src=${fileUrl}`;
      break;
    case 'word':
      // Microsoft Office Online Word Viewer
      viewerUrl = `https://view.officeapps.live.com/op/embed.aspx?src=${fileUrl}`;
      break;
    case 'powerpoint':
      // Microsoft Office Online PowerPoint Viewer
      viewerUrl = `https://view.officeapps.live.com/op/embed.aspx?src=${fileUrl}`;
      break;
    default:
      return;
  }

  // Buka di tab baru
  window.open(viewerUrl, '_blank', 'width=1200,height=800,scrollbars=yes,resizable=yes');
}

// Method untuk membuka Google Docs Viewer sebagai alternatif
const openGoogleViewer = () => {
  const fileUrl = encodeURIComponent(previewModal.value.primaryFile)
  const viewerUrl = `https://docs.google.com/viewer?url=${fileUrl}&embedded=true`
  window.open(viewerUrl, '_blank', 'width=1200,height=800,scrollbars=yes,resizable=yes');
}

// Method untuk mendapatkan Office Viewer URL yang embedded
const getOfficeViewerUrl = (type) => {
  const fileUrl = encodeURIComponent(previewModal.value.primaryFile)
  return `https://view.officeapps.live.com/op/embed.aspx?src=${fileUrl}&wdStartOn=1`
}

// Handle error saat Office Preview gagal
const handleOfficePreviewError = () => {
  showOfficePreview.value = false
  console.warn('Office Online preview failed, falling back to options')
}

// State untuk text preview
const textPreview = ref({ loading: false, content: '', error: '' })

// Method untuk load text file content
const loadTextPreview = async () => {
  textPreview.value.loading = true
  textPreview.value.error = ''

  try {
    const response = await fetch(previewModal.value.primaryFile)
    if (!response.ok) throw new Error('Gagal memuat file')

    const content = await response.text()
    textPreview.value.content = content.length > 5000
      ? content.substring(0, 5000) + '\n\n... (Preview dibatasi 5000 karakter pertama)'
      : content

    showTextPreview.value = true
  } catch (error) {
    textPreview.value.error = 'Gagal memuat konten file: ' + error.message
  } finally {
    textPreview.value.loading = false
  }
}

const showTextPreview = ref(false)
</script>
<style scoped>
@keyframes flashHighlight {
  0% {
    background-color: #fef3c7;
  }

  50% {
    background-color: #fde68a;
  }

  100% {
    background-color: transparent;
  }
}

.animate-highlight {
  animation: flashHighlight 2.5s ease-in-out 1;
}

.drag-over-target {
  background-color: #eef2ff;
}
</style>
